import { EvaluatedFactor, Factor } from './factor';

export interface ICarbonCausalChain {
  ccc: string;
  version: string;
  work: Work[];
  operation: Operation;
  costs?: Cost[];
}

export interface Operation {
  growthType: OperationGrowthType;
  variable: string;
  growthFactor?: Factor;
  primaryStock?: string;
}

export enum OperationGrowthType {
  No = 'NO',
  Only = 'ONLY',
  Yes = 'YES',
}

// Work related models
export interface Work {
  work: string;
  unitOfMeasure: string;
  operationToWork: Factor | EvaluatedFactor;
  input: Input[];
  output?: Output[];
}

export interface Input {
  resource: string;
  emissionFactor: Factor | EvaluatedFactor;
  resourceProportion?: string;
  resourceToWork: Factor | EvaluatedFactor;
  unitOfMeasure: string;
}

export interface Output {
  resource: string;
  unitOfMeasure: string;
  workToResource: Factor | EvaluatedFactor;
  primary?: boolean;
}

export const WORK_TO_SKIP = ['deprecated']; //Temporary base for filtering

// Cost related models
export interface Cost {
  name: string;
  type: CostType;
  costFactor: Factor | EvaluatedFactor;
  unitOfMeasure?: string;
  stocks?: CostStock[];
  resources?: CostResource[];
  externalities?: CostExternality[];
  globalExternalities?: GlobalCostExternality[];
}

export enum CostType {
  Capex = 'CAPEX',
  Opex = 'OPEX',
  Posext = 'POSEXT',
  Negext = 'NEGEXT',
}

export interface CostStock {
  stock: string;
  pricePerUnit: string;
  relativePriceChange?: string;
}

export interface CostResource {
  resource: string;
  pricePerUnit: string;
  relativePriceChange?: string;
}

export interface CostExternality {
  externality: string;
  pricePerFunctionUnit?: string;
  relativePriceChange?: string;
}
export interface GlobalCostExternality {
  externality: string;
}
